'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var stopPropagation = exports.stopPropagation = function stopPropagation(event) {

  if (!event) {
    return;
  }

  if (typeof event.preventDefault === 'function') {
    event.preventDefault();
  }

  if (typeof event.stopPropagation === 'function') {
    event.stopPropagation();
  }

  if (event.nativeEvent && typeof event.nativeEvent.stopImmediatePropagation === 'function') {
    event.nativeEvent.stopImmediatePropagation();
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/arreeba-form/lib/lib/browser.js
// module id = 294
// module chunks = 0